module.exports = __webpack_public_path__ + "static/media/driver.50aca9b7.svg";